import React from "react";
import EbikeCard from "../molecules/ebikeCard";
import Heading from "../molecules/heading";
import Navbar from "../molecules/navbar";
import OtherEBikes from "../molecules/otherEBikes";
import { Div, Image } from "atomize";
import left_bg from "../../assets/images/Vector.png";
import rigth_bg from "../../assets/images/Vector-right.png";
import header_side_image from "../../assets/images/header-side-image.png";
import HybrydeBikes from "../molecules/hybrydeBikes";
import CustomerView from "../molecules/customerView";
import Footer from "./footer";

const Layout = () => {
  return (
    <Div>
      <Div className="row">
        <Div className="col-md-2"></Div>
        <Div className="col-md-8">
          <Navbar />
        </Div>
        <Div className="col-md-2"></Div>
      </Div>
      <Div className="row">
        <Div className="col-md-2" d={{ xs: "none", md: "flex" }}>
          <Image
            src={header_side_image}
            alt="header side image"
            w="100px"
            h="150px"
          />
        </Div>
        <Div className="col-md-8">
          <Heading />
        </Div>
        <Div className="col-md-2"></Div>
      </Div>
      <Div className="row">
        <Div className="col-md-2" d={{ xs: "none", md: "flex" }}>
          <Image
            src={left_bg}
            alt="left-image"
            w="500px"
            h="400px"
            style={{
              position: "relative",
              top: "120px",
            }}
          />
        </Div>
        <Div className="col-md-10">
          {" "}
          <EbikeCard />
        </Div>
      </Div>
      <Div className="row">
        <Div className="col-md-9"></Div>
        <Div className="col-md-3">{/*  */}</Div>
      </Div>
      <Div className="row">
        <Div className="col-md-2"></Div>
        <Div className="col-md-10">
          {" "}
          <OtherEBikes />
        </Div>
      </Div>
      <Div className="row">
        <Div className="col-md-2"></Div>
        <Div className="col-md-8" style={{ position: "relative", zIndex: "1" }}>
          <HybrydeBikes />
        </Div>
        <Div className="col-md-2" d={{ xs: "none", md: "flex" }}>
          <Image
            src={rigth_bg}
            alt="left-image"
            w="500px"
            h="400px"
            style={{
              position: "relative",
              top: "130px",
              right: "200px",
            }}
          />
        </Div>
      </Div>
      <Div className="row">
        <Div className="col-md-2"></Div>
        <Div className="col-md-8">
          <CustomerView />
        </Div>
        <Div className="col-md-2"></Div>
      </Div>
      <Footer />
    </Div>
  );
};

export default Layout;
